<template>
  <Spinner v-if="resetPasswordStore.isLoading" />
  <div id="bst-wrap">
      <div class="l-project-wrap l-project-wrap--login">
        <!-- header -->
        <section class="l-content-area">
          <div class="l-content">
            <section class="p-bloc p-bloc--login">
              <div class="p-bloc__content l-wrap__outer">
                <div class="l-wrap__inner">
                  <div class="login-box">
                    <div class="p-login__title">
                      <div class="logo"><img src="@/assets/img/login/logo.png" alt="hubsynch"></div>
                      <h1>{{ $t('TITLE_REMINDER_PAGE') }}</h1>
                    </div>
                    <!-- reminder -->
                    <section class="p-reminder c-register-parts">
                      <p v-html="$t('TEXT_REMINDER_PAGE')"></p>
                      <form @submit.prevent="resetPassword()">
                        <div class="p-reminder__form">
                          <div class="mailaddress">
                            <div class="input-area" :class="{ 'is-error': v$.email.$error || resetPasswordStore.errorMessage }">
                                <!-- TODO: When there is an error, add "is-error" class to this "div.input-area" -->
                              <input id="input-email" type="email" name="email" class="plchldr" :placeholder="$t('LABEL_EMAIL')" v-model="resetPasswordStore.resetPasswordForm.email">
                            </div>
                            <p class="error-txt" v-if="v$.email.$error">{{ $t(v$.email.$errors[0].$message) }}</p>
                            <p class="error-txt" v-if="resetPasswordStore.errorMessage">{{ resetPasswordStore.errorMessage }}</p>
                          </div>
                          <div class="c-btn c-btn--reminder"><input id="button-send" type="submit" :value="$t('LABEL_BUTTON_SEND_REMINDER')"></div>
                        </div>
                        <div class="p-reminder__back">
                          <div class="c-btn c-btn--tologin"><a id="link-login" href="/login">{{ $t('LABEL_BUTTON_TO_LOGIN_PAGE') }}</a></div>
                        </div>
                      </form>
                    </section>
                  </div><!-- .bg-box -->
                </div>
              </div>
            </section>
          </div><!-- .l-content -->
        </section><!-- .l-content-area -->

      </div><!-- .l-project-wrap -->

      <!-- footer -->

    </div>
</template>

<script setup>

import { useResetPasswordStore } from "@/stores/resetPasswordStore";
import Spinner from "@/components/Spinner.vue";
import { useVuelidate } from '@vuelidate/core';
import { getResetPasswordRules } from "@/validations/resetPasswordValidation";
import router from "@/router";
import { useI18n } from 'vue-i18n';

let resetPasswordStore = useResetPasswordStore();

const { t } = useI18n();
const v$ = useVuelidate(getResetPasswordRules(t), resetPasswordStore.resetPasswordForm);

async function resetPassword() {
    if (!await v$.value.$validate()) {
        return false;
    }
    if(await resetPasswordStore.resetPassword()){
        await router.push({ name: "reminder.complete" });
    }
}
</script>